import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

export const kustoMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.kusto.linkedServiceType,
    displayName: stringResources.Kusto_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-azure_kusto'
    },
    isFirstClass: true,
    category: ['ServicesApps'],
    copySinkTypes: [],
    copySourceTypes: [], // since this is only used by copy wizard and copy wizard doesn't support kusto now, set is as empty.
    disableQueryAPI: true,
    controls: [
        {
            type: 'textbox',
            bind: 'endpoint',
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            label: stringResources.ModelName_Endpoint,
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'servicePrincipalId',
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            label: stringResources.ModelName_ServicePrincipalID,
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'servicePrincipalKey',
            label: stringResources.ModelName_ServicePrincipalKey,
            child: {
                type: 'password',
                label: stringResources.ModelName_ServicePrincipalKey,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Kusto_DisplayText),
                stringResources.ModelName_ServicePrincipalKey)
        }
    ]
};
